import { ProcedureStepFieldsAttachmentService as OvermapProcedureStepFieldsAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureStepFieldsAttachmentService extends OvermapProcedureStepFieldsAttachmentService<
	RootState,
	AppSDK
> {
	host = import.meta.env.REACT_APP_API_URL
}
